import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKonten',
    name: 'DaftarKonten',
    component: () => import('../../components/views/Publik/DaftarKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarBerita',
    name: 'DaftarBerita',
    component: () => import('../../components/views/Publik/DaftarBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarDokumen',
    name: 'DaftarDokumen',
    component: () => import('../../components/views/Publik/DaftarDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleri',
    name: 'DaftarGaleri',
    component: () => import('../../components/views/Publik/DaftarGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GIS',
    name: 'GIS',
    component: () => import('../../components/views/Publik/GIS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InputAduan',
    name: 'InputAduan',
    component: () => import('../../components/views/Publik/InputAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CariAduan',
    name: 'CariAduan',
    component: () => import('../../components/views/Publik/CariAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/MonitoringAduan',
    name: 'MonitoringAduan',
    component: () => import('../../components/views/Publik/MonitoringAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarProgramBudgeting',
    name: 'DaftarProgramBudgeting',
    component: () => import('../../components/views/Publik/DaftarProgramBudgeting.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarFinance',
    name: 'DaftarFinance',
    component: () => import('../../components/views/Publik/DaftarFinance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGESIAP',
    name: 'DaftarGESIAP',
    component: () => import('../../components/views/Publik/DaftarGESIAP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konten',
    name: 'Konten',
    component: () => import('../../components/views/Backoffice/Konten/Konten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKonten/:id',
    name: 'ProsesKonten',
    component: () => import('../../components/views/Backoffice/Konten/ProsesKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: () => import('../../components/views/Backoffice/Berita/Berita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesBerita/:id',
    name: 'ProsesBerita',
    component: () => import('../../components/views/Backoffice/Berita/ProsesBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DataDokumen',
    name: 'DataDokumen',
    component: () => import('../../components/views/Backoffice/NewDokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Galeri',
    name: 'Galeri',
    component: () => import('../../components/views/Backoffice/Galeri/Galeri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGaleri/:id',
    name: 'ProsesGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/ProsesGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailGaleri/:id',
    name: 'DetailGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/DetailGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LayerPeta',
    name: 'LayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/LayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Monev',
    name: 'Monev',
    component: () => import('../../components/views/Backoffice/Monev/Monev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesMonev/:id',
    name: 'ProsesMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPDOMonev/:id',
    name: 'ProsesPDOMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesPDOMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AduanMasyarakat',
    name: 'AduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesAduanMasyarakat/:id',
    name: 'ProsesAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/TindaklanjutAduanMasyarakat/:id',
    name: 'TindaklanjutAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDOIOS',
    name: 'PDOIOS',
    component: () => import('../../components/views/Backoffice/PDOIOS/PDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPDOIOS/:id',
    name: 'ProsesPDOIOS',
    component: () => import('../../components/views/Backoffice/PDOIOS/ProsesPDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Kegiatan',
    name: 'Kegiatan',
    component: () => import('../../components/views/Backoffice/Kegiatan/Kegiatan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKegiatan/:id',
    name: 'ProsesKegiatan',
    component: () => import('../../components/views/Backoffice/Kegiatan/ProsesKegiatan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Program',
    name: 'Program',
    component: () => import('../../components/views/Backoffice/Program/Program.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesProgram/:id',
    name: 'ProsesProgram',
    component: () => import('../../components/views/Backoffice/Program/ProsesProgram.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Procurement',
    name: 'Procurement',
    component: () => import('../../components/views/Backoffice/Procurement/Procurement.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesProcurement/:id',
    name: 'ProsesProcurement',
    component: () => import('../../components/views/Backoffice/Procurement/ProsesProcurement.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Finance',
    name: 'Finance',
    component: () => import('../../components/views/Backoffice/Finance/Finance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesFinance/:id',
    name: 'ProsesFinance',
    component: () => import('../../components/views/Backoffice/Finance/ProsesFinance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Social',
    name: 'Social',
    component: () => import('../../components/views/Backoffice/Social/Social.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSocial/:id',
    name: 'ProsesSocial',
    component: () => import('../../components/views/Backoffice/Social/ProsesSocial.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Environment',
    name: 'Environment',
    component: () => import('../../components/views/Backoffice/Environment/Environment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesEnvironment/:id',
    name: 'ProsesEnvironment',
    component: () => import('../../components/views/Backoffice/Environment/ProsesEnvironment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Gesiap',
    name: 'Gesiap',
    component: () => import('../../components/views/Backoffice/Gesiap/Gesiap.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGesiap/:id',
    name: 'ProsesGesiap',
    component: () => import('../../components/views/Backoffice/Gesiap/ProsesGesiap.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SettingMenu',
    name: 'SettingMenu',
    component: () => import('../../components/views/Backoffice/SettingMenu/SettingMenu.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
